import $ from 'init/jquery'
import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { Preloader } from '../models/preloader'
import { getTemplate } from 'helpers/template-helper'

/**
 * Прелоадер.
 *
 * Вставка прелоадера происходит в body по центру экрана.
 */
@Defaults({
  id: 'circularG',
  className: 'preloader',
  templateId: '#preloader',
  isNewInfiniteLoader: false,
})
export class PreloaderView extends View {
  /** @inheritDoc */
  run () {
    this.model = new Preloader()
    this.infinitePreloaderTemplate = getTemplate(this.templateId)
  }

  /** @inheritDoc */
  remove () {
    this.model.set('isActivePreloader', false)
    this.$el.remove()
    this.stopListening()
    return this
  }

  /** @inheritDoc */
  render (qtyShown, qtyTotal) {
    const top = $(window).scrollTop() + $(window).height() / 2
    this.$el.html(this.infinitePreloaderTemplate({
      qty: {
        shown: qtyShown,
        total: qtyTotal,
      },
      isNewInfiniteLoader: this.isNewInfiniteLoader,
    }))
    if (qtyShown && qtyTotal) {
      this.$el.addClass('infinite-preloader')
      this.$el.appendTo('.infinityScrollData')
    } else {
      this.$el.removeClass('infinite-preloader')
      this.$el.css({ 'top': top })
      this.$el.appendTo('body')
    }
    this.model.set('isActivePreloader', true)

    return this
  }
}
